/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { TalentPoolUpdateRequestColor } from './talentPoolUpdateRequestColor';
import type { TalentPoolUpdateRequestIcon } from './talentPoolUpdateRequestIcon';

export interface TalentPoolUpdateRequest {
  icon?: TalentPoolUpdateRequestIcon;
  color?: TalentPoolUpdateRequestColor;
  name?: string | null;
  disabled_filter_categories?: string[] | null;
}
